import { render } from "./AccessWalletModal.vue?vue&type=template&id=7221ac21"
import script from "./AccessWalletModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessWalletModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/import_modals/AccessWalletModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7221ac21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7221ac21', __exports__)) {
    api.reload('7221ac21', __exports__)
  }
  
  module.hot.accept("./AccessWalletModal.vue?vue&type=template&id=7221ac21", () => {
    api.rerender('7221ac21', render)
  })

}


export default __exports__